import React from "react";
import FooterMenu from "./componenteshome/footer";
import MenuEscritorio from "./componenteshome/MenuEscritorio";
import Amigos from "./componentesamigos/amigos";
export default function DisenoAmigos() {
  return (
    <div>
      <Amigos />
      <MenuEscritorio />
    </div>
  );
}
